// BL-2339 (PRJ-91 — Offline mode for the admin mobile app): the reads the phone polls to
// stay current while it can. Declared here, in one file, so the parallel PRJ-91 items that
// add offline routes extend this file rather than reshuffling an existing area.
import { responseType } from '@auctogon/core/api/registry';
import { defineAdminRoute } from './define-admin-route';
import { LOT_EDIT_MODAL_READ } from './lots';
// Type-only import (erased at build) — keeps the registry client-bundle-safe.
import type { OfflineAuctionDeltaDto } from '../../schemas/responses/offline-sync';

export const offline = {
  // One auction's changes since the phone's cursor (ADR 042 — Lots Machinery series).
  // Offline inherits the online grants unchanged: the delta carries the list row
  // (`GET /api/inventory`), the lot detail (`GET /api/lots/:id`) and the lot's notes, all
  // three gated on `LOT_EDIT_MODAL_READ` online, so the delta is gated on exactly that.
  // `withDeleted`: a deleted own-tenant sale answers "no longer eligible" so the
  // phone drops it; another tenant's sale is still a 404.
  auction_delta: defineAdminRoute({
    path: '/api/auctions/:id/offline-delta',
    params: { id: '' },
    methods: {
      GET: {
        grant: LOT_EDIT_MODAL_READ,
        tenant: { from: 'record', table: 'auction', param: 'id', withDeleted: true },
        response: responseType<OfflineAuctionDeltaDto>(),
        query: { since_sequence: '', since_at: '', notes_since: '', notes_after: '', limit: '' },
      },
    },
  }),
  // BL-2675 (PRJ-102): a few hundred thumbnails in one streamed tar, so the phone's background download is a few
  // hundred tasks, not 250,000. Same floor as the delta: the phone that can sync can download. The success body is a
  // tar file, not a DTO (precedent `inventory.export`); the manifest in its last entry is the one declared shape.
  thumbnail_batch: defineAdminRoute({
    path: '/api/auctions/:id/offline-thumbnails',
    params: { id: '' },
    methods: {
      POST: {
        grant: LOT_EDIT_MODAL_READ,
        tenant: { from: 'record', table: 'auction', param: 'id', withDeleted: true },
      },
    },
  }),
};
